import { UPDATE_SHOPPER } from './types'

export const UpdateShopper = payload => {
  return {
    type: UPDATE_SHOPPER,
    payload,
  }
}
